<template>
  <v-app>
    <v-main>

      <router-view v-slot="{ Component }">
        <div>
          <GlobalHeader/>
          <transition name="fade">
            <component :is="Component"/>
          </transition>
          <GlobalFooter/>

        </div>
      </router-view>
      <v-fab
          :app="true"
          extended
          color="rgb(27 132 255 / var(--tw-bg-opacity, 1))"
          location="right bottom"
          style="z-index: 15"
          class="text-white"
          to="/inquiry"
      >
        <span class="text-white">{{$t('inquiry')}}</span>
     </v-fab>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import GlobalHeader from "@/components/GlobalHeader/GlobalHeader.vue";
import GlobalFooter from "@/components/GlobalFooter/GlobalFooter.vue";
import {useRouter} from "vue-router";

const router = useRouter();
const inquiry = ()=>{
  router.push('/inquiry')
}

</script>

<style scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.1s ease-out;
}

.fade-leave-active {
  transition: opacity 0.1s ease-in;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>